module.exports = __webpack_public_path__ + "media/application/images/icons/building-4889fedea4f4a6f029728bd3847a6407.svg";